<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Meta Tags</h3>
			<lang-selector></lang-selector>
		</header>
		<div class="card-body">
			<section>
				<h4 class="card-subtitle">Currently Used Meta Tags</h4>
				<div class="table-responsive">
					<table>
						<thead>
							<tr>
								<th>Key</th>
								<th>Value</th>
								<th>Code Preview</th>
								<th class="actions" v-if="cardUserRoles.includes('articles.update')">Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(currentMeta, currentMetaIndex) in cardCurrentMetas" v-if="currentMeta.values[cardClickedLang].content !== ''">
								<td>{{ currentMeta.key }}</td>
								<td>
									<span>{{ currentMeta.values[cardClickedLang].content }}</span>
								</td>
								<td>
									<code>{{ currentMeta.previews[cardClickedLang] }}</code>
								</td>
								<td v-if="cardUserRoles.includes('articles.update')">
									<button
											@click="showMetaTagModal(currentMetaIndex)"
											class="btn btn-icon btn-primary"
											title="Edit"
									>
										<i class="fas fa-fw fa-pencil-alt"></i>
									</button>
									<button
											@click="deleteMetaTag(currentMetaIndex)"
											class="btn btn-icon btn-danger"
											title="Delete"
									>
										<i class="fas fa-fw fa-trash"></i>
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<section v-if="cardUserRoles.includes('articles.update')">
				<h4 class="card-subtitle">Add New Meta Tag</h4>
				<div class="flex box end">
					<div class="form-group four mb-0">
						<label for="meta-name">Meta Name</label>
						<select id="meta-name" required v-model="selectedMetaName">
							<optgroup :label="metaGroupIndex" v-for="( metaGroupName, metaGroupIndex ) in cardMetas">
								<option v-for="( metaName, metaIndex ) in cardMetas[metaGroupIndex]">{{ metaGroupIndex+'.'+metaIndex }}</option>
							</optgroup>
						</select>
					</div>
					<div class="form-group four mb-0">
						<label class="control-label" for="meta-value">Meta Value</label>
						<vue-select
								:options="metaValues"
								id="meta-value"
								name="meta-value"
								required
								taggable
								v-model="selectedMetaValue"
						>
						</vue-select>
					</div>
					<a @click.prevent="addNewMetaTag(selectedMetaValue.value,selectedMetaValue.label,selectedMetaName)" class="btn btn-primary four" href="#">
						<i class="fas fa-plus"></i> Add
					</a>
				</div>
			</section>
		</div>

		<!--MODAL-->
		<modal @close="closeMetaTagModal" v-show="isMetaTagModalVisible">
			<template slot="header">
				<h4 class="modal-title">Edit Meta Tag</h4>
			</template>
			<template slot="body">
				<div class="form-group">
					<label>Edited key: {{ currentlyEditedMeta.key }}</label>
					<vue-select
							:options="metaValues"
							@search:focus="editTypedTextMetaValue"
							ref="editMetaInVueSelect"
							required
							taggable
							v-model="currentlyEditedMeta.values[cardClickedLang].content"
					>
					</vue-select>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeMetaTagModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a @click="saveMetaEditChanges" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
		<!--/ MODAL END-->

	</div>
</template>

<script>
	import {eventBus} from '../app';
	import VueSelect from '../../../node_modules/vue-select';
	import modal from '../components/Modal/DefaultModal.vue';

	export default {
		name: 'MetaTagsCard',
		components: {
			"vue-select": VueSelect,
			"modal": modal
		},
		props: {
			dataCardInstanceId: {
				type: Number
			},
			dataCardMetaSeoBox: {
				type: Object
			}
		},
		data() {
			return {
				cardInstanceId: this.dataCardInstanceId,
				cardClickedLang: this.$defaultLanguage.locale,
				cardCurrentMetas: this.dataCardMetaSeoBox.currentMetas ? this.dataCardMetaSeoBox.currentMetas : {},
				cardMetas: this.dataCardMetaSeoBox.metas ? this.dataCardMetaSeoBox.metas : {},
				cardTags: this.dataCardMetaSeoBox.tags ? this.dataCardMetaSeoBox.tags : {},
				metasForSave: {},
				selectedMetaName: "",
				selectedMetaValue: "",
				isMetaTagModalVisible: false,
				currentlyEditedMeta: {
					id: 0,
					key: '',
					previews: {},
					targetId: 0,
					values: {}
				},
				cardUserRoles: this.$currentUserRoles,
			}
		},
		created() {
			let vm = this;

			for (let lang in vm.$availableLanguages) {
				vm.currentlyEditedMeta.values[vm.$availableLanguages[lang].locale] = {
					content: ""
				};
				vm.currentlyEditedMeta.previews[vm.$availableLanguages[lang].locale] = "";
			}

			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.cardClickedLang = clickedLang;

				eventBus.$emit('pushActiveStatus', {locale: clickedLang});
			});

		},
		computed: {
			metaValues: function () {
				let arrayHelper = [];

				for (let tag in this.cardTags) {
					arrayHelper.push({
						value: tag,
						label: this.cardTags[tag]
					});
				}

				return arrayHelper;
			},
			selectedMetaCodePreview: function () {
				let vm = this;
				let selectedPattern = '';
				let newContentToPatternPredefined = vm.selectedMetaValue.value ? vm.selectedMetaValue.value : '';
				let newContentToPatternTyped = vm.selectedMetaValue.label ? vm._escapeHtmlTagsFromMetaValue(vm.selectedMetaValue.label) : '';

				for (let metaCategory in vm.cardMetas) {
					for (let metaNameInCategory in vm.cardMetas[metaCategory]) {
						if (metaNameInCategory == vm.selectedMetaName.substring(vm.selectedMetaName.indexOf('.') + 1)) {
							selectedPattern = vm.cardMetas[metaCategory][metaNameInCategory].pattern;
							break;
						}
					}
				}
				if (newContentToPatternPredefined != '') {
					return selectedPattern.replace('#content#', newContentToPatternPredefined);
				} else {
					return selectedPattern.replace('#content#', newContentToPatternTyped);
				}
			}
		},
		methods: {
			deleteMetaTag: function (metaIndex) {
				this.cardCurrentMetas[metaIndex].values[this.cardClickedLang].content = '';
				this.cardCurrentMetas[metaIndex].previews[this.cardClickedLang] = '';

				eventBus.$emit('updateMetaTags', {currentMetas: this.cardCurrentMetas});
			},

			addNewMetaTag: function (metaId, metaValue, metaName) {
				let vm = this;
				let values = {};
				let previews = {};

				if (metaName === '' || metaName === null || metaValue === '' || metaValue === null) {
					this.$toastr.error('Please select one Meta name or value', 'Error');
					return;
				}

				for (let lang in vm.$availableLanguages) {
					if (vm.$availableLanguages[lang].locale === vm.cardClickedLang) {
						previews[vm.$availableLanguages[lang].locale] = vm.selectedMetaCodePreview;

						values[vm.$availableLanguages[lang].locale] = {
							content: this._escapeHtmlTagsFromMetaValue(metaValue)
						}
					} else {
						previews[vm.$availableLanguages[lang].locale] = "";
						values[vm.$availableLanguages[lang].locale] = {content: ""};
					}
				}

				vm.cardCurrentMetas.push({
					id: metaId,
					group: '',
					key: metaName,
					previews: previews,
					targetId: vm.instanceId,
					values: values
				});

				eventBus.$emit('updateMetaTags', {currentMetas: vm.cardCurrentMetas});
				return vm.cardCurrentMetas;
			},

			closeMetaTagModal: function () {
				this.isMetaTagModalVisible = false;
			},

			showMetaTagModal: function (metaId) {
				let vm = this;
				let values = {};
				let previews = {};

				for (let lang in vm.$availableLanguages) {
					if (vm.$availableLanguages[lang].locale === vm.cardClickedLang) {
						previews[vm.$availableLanguages[lang].locale] = this._escapeHtmlTagsFromMetaValue(vm.cardCurrentMetas[metaId].previews[vm.cardClickedLang]);

						values[vm.$availableLanguages[lang].locale] = {
							content: {
								label: this._escapeHtmlTagsFromMetaValue(vm.cardCurrentMetas[metaId].values[vm.cardClickedLang].content),
								value: this._escapeHtmlTagsFromMetaValue(vm.cardCurrentMetas[metaId].values[vm.cardClickedLang].content)
							}
						}
					} else {
						previews[vm.$availableLanguages[lang].locale] = "";
						values[vm.$availableLanguages[lang].locale] = {content: ""};

					}
				}

				vm.isMetaTagModalVisible = true;
				vm.currentlyEditedMeta = {
					id: metaId,
					key: vm.cardCurrentMetas[metaId].key,
					previews: previews,
					targetId: vm.cardCurrentMetas[metaId].targetId,
					values: values
				};
			},

			editTypedTextMetaValue: function () {
				let vm = this;
				let foundMetaValueLikeThis = false;

				for (let optionLabel in vm.$refs.editMetaInVueSelect.mutableOptions) {
					if (vm.$refs.editMetaInVueSelect.mutableOptions[optionLabel].label == vm.$refs.editMetaInVueSelect.mutableValue.label) {
						foundMetaValueLikeThis = true;
						break;
					}
				}

				// Ha nem talált egyezést a meglévő metaValue-kkal, akkor ez egy begépelt szöveg
				if (foundMetaValueLikeThis === false) {
					return vm.$refs.editMetaInVueSelect.search = vm.$refs.editMetaInVueSelect.mutableValue.label;
				}
			},

			saveMetaEditChanges: function () {
				let vm = this;
				let contentToInsertIntoPreview = '';

				if (vm.currentlyEditedMeta.values[vm.cardClickedLang].content.value) {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.cardClickedLang].content.value;
				} else if (vm.currentlyEditedMeta.values[vm.cardClickedLang].content.label) {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.cardClickedLang].content.label;
				} else {
					contentToInsertIntoPreview = vm.currentlyEditedMeta.values[vm.cardClickedLang].content;
				}

				vm.cardCurrentMetas[vm.currentlyEditedMeta.id].previews[vm.cardClickedLang] = this._setCodePreview(vm.currentlyEditedMeta.key, vm.cardCurrentMetas[vm.currentlyEditedMeta.id].values[vm.cardClickedLang].content, contentToInsertIntoPreview);
				vm.cardCurrentMetas[vm.currentlyEditedMeta.id].values[vm.cardClickedLang].content = this._escapeHtmlTagsFromMetaValue(contentToInsertIntoPreview);

				eventBus.$emit('updateMetaTags', {currentMetas: vm.cardCurrentMetas});
				this.closeMetaTagModal();
			},

			_escapeSpecialCharsFromMetaValue: function (patternToEscape) {
				const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·_,:;';
				const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz-----';
				const p = new RegExp(a.split('').join('|'), 'g');

				let escapedPattern = patternToEscape.toString().toLowerCase()
						.replace(/\s+/g, '-') // Replace spaces with -
						.replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
						.replace(/&/g, '-and-') // Replace & with ‘and’
						.replace(/[^\w\-\/]+/g, '') // Remove all non-word characters
						.replace(/\-\-+/g, '-') // Replace multiple - with single -
						.replace(/^-+/, '') // Trim - from start of text
						.replace(/-+$/, ''); // Trim - from end of text

				return escapedPattern;
			},

			_escapeHtmlTagsFromMetaValue: function (stringToEscape) {
				return stringToEscape.replace(/(<([^>]+)>)/ig, "");
			},

			_setCodePreview: function (metaName, textToChange, textToInsertIntoPreview) {
				let previewPattern = '';
				let oldTagKeyToChange = '';
				textToInsertIntoPreview = this._escapeHtmlTagsFromMetaValue(textToInsertIntoPreview);

				// Find tag id by tag name
				for (let tagName in this.cardTags) {
					if (this.cardTags[tagName] == textToChange) {
						oldTagKeyToChange = tagName;
						break;
					}
				}

				//magic
				let metaGroup = metaName.split('.')[0];
				metaName = metaName.slice(metaName.indexOf('.') + 1);

				// Get preview by meta name
				for (let metaCategory in this.cardMetas) {
					if (metaCategory == metaGroup) {
						for (let metaNameInCategory in this.cardMetas[metaCategory]) {
							if (metaNameInCategory == metaName) {
								previewPattern = this.cardMetas[metaCategory][metaNameInCategory].pattern;
								break;
							}
						}
					}
				}
				return previewPattern.replace(/\#(.+)\#/g, textToInsertIntoPreview);
			}
		}
	}
</script>

<style scoped>

</style>
